import React, { useContext } from 'react';

import { media } from 'context';
import { Layout, Link } from 'ds';

import { ReactComponent as Facebook } from 'assets/images/footer/facebook-logo.svg';
import { ReactComponent as Instagram } from 'assets/images/footer/instagram-logo.svg';
import { ReactComponent as LinkedIn } from 'assets/images/footer/linkedin-logo.svg';
import { ReactComponent as X } from 'assets/images/footer/x-logo.svg';

interface Props {}

const FooterAppStoreSocialLinks: React.FC<Props> = () => {
  const { isMobile } = useContext(media);

  return (
    <>
      <Layout {...(isMobile ? { marginTop: 56 } : {})}>
        <Layout {...(isMobile ? { justify: 'flex-start', width: '100%' } : {})} flex>
          <Layout display="inline-flex">
            <Link href="https://www.linkedin.com/company/codiwork/about" target="_blank">
              <span className="Icon is-color-white">
                <LinkedIn width={24} height={24} />
              </span>
            </Link>
          </Layout>
          <Layout marginLeft={24} display="inline-flex">
            <Link href="https://twitter.com/codiwork" target="_blank">
              <span className="Icon is-color-white">
                <X width={24} height={24} />
              </span>
            </Link>
          </Layout>
          <Layout marginLeft={24} display="inline-flex">
            <Link href="https://www.facebook.com/codicommunity" target="_blank">
              <span className="Icon is-color-white">
                <Facebook width={24} height={24} />
              </span>
            </Link>
          </Layout>
          <Layout marginLeft={24} display="inline-flex">
            <Link href="https://www.instagram.com/codiwork" target="_blank">
              <span className="Icon is-color-white">
                <Instagram width={24} height={24} />
              </span>
            </Link>
          </Layout>
        </Layout>
      </Layout>
    </>
  );
};

export default FooterAppStoreSocialLinks;
